// Approved countries for login
export const APPROVED_COUNTRIES = [
  { iso2: "IN", name: "India", dialCode: "+91" },
  { iso2: "NZ", name: "New Zealand", dialCode: "+64" },
  { iso2: "AE", name: "United Arab Emirates", dialCode: "+971" },
  { iso2: "GB", name: "United Kingdom", dialCode: "+44" },
  { iso2: "BH", name: "Bahrain", dialCode: "+973" },
  { iso2: "US", name: "United States", dialCode: "+1" },
  { iso2: "SG", name: "Singapore", dialCode: "+65" },
  { iso2: "CA", name: "Canada", dialCode: "+1" },
  { iso2: "IE", name: "Ireland", dialCode: "+353" },
  { iso2: "KW", name: "Kuwait", dialCode: "+965" },
  { iso2: "KR", name: "South Korea", dialCode: "+82" },
  { iso2: "AU", name: "Australia", dialCode: "+61" },
  { iso2: "FI", name: "Finland", dialCode: "+358" },
  { iso2: "QA", name: "Qatar", dialCode: "+974" },
  { iso2: "NP", name: "Nepal", dialCode: "+977" },
  { iso2: "SA", name: "Saudi Arabia", dialCode: "+966" },
  { iso2: "FR", name: "France", dialCode: "+33" },
];

export const APPROVED_COUNTRY_ISO_CODES = APPROVED_COUNTRIES.map((c) => c.iso2);

export const isCountryApproved = (iso2) => {
  if (!iso2) return false;
  return APPROVED_COUNTRY_ISO_CODES.includes(iso2);
};

export const isDialCodeApproved = (countryCode) => {
  if (!countryCode) return false;
  return APPROVED_COUNTRIES.some((c) => c.dialCode === countryCode);
};
